import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

// 시안과 같은 순서: 페이지 CSS → 공통 CSS (각 파일은 [data-ib-page] 범위로 나뉘어 있어 서로 섞이지 않음)
import "./styles/pages/home.css";
import "./styles/pages/about.css";
import "./styles/pages/business.css";
import "./styles/pages/portfolio.css";
import "./styles/pages/brands.css";
import "./styles/pages/contact.css";
import "./styles/pages/notfound.css";
import "./styles/common.css";
import "./styles/motion.css"; // 사이트 공통 움직임(시안 CSS 위에 덧붙임)

import App from "./App";

// 예전 주소(원페이지 시절 #about · #business · #contact)로 들어오면 새 페이지로 보낸다
const LEGACY_HASH = { "#about": "/about", "#business": "/business", "#contact": "/contact" };
if (window.location.pathname === "/" && LEGACY_HASH[window.location.hash]) {
  window.history.replaceState(null, "", LEGACY_HASH[window.location.hash]);
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
